import type { ConfigProviderProps } from 'antd/es/config-provider';

import { css } from 'config/emotionCss';

const leavingNoticeStyle = css`
  &.ant-notification-fade-leave {
    pointer-events: none;
  }
`;

const notificationConfig: ConfigProviderProps['notification'] = {
  classNames: { root: leavingNoticeStyle },
};

export default notificationConfig;
